"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttemptRubricSelectionSerializer = void 0;
var models_1 = require("../../models");
var AttemptRubricSelectionSerializer = /** @class */ (function () {
    function AttemptRubricSelectionSerializer(attemptSerializer) {
        this.attemptSerializer = attemptSerializer;
    }
    AttemptRubricSelectionSerializer.prototype.serialize = function (_a) {
        var _this = this;
        var id = _a.id, attempt = _a.attempt, responses = _a.responses;
        return new models_1.AttemptRubricSelection({
            id: id,
            attempt: attempt ? this.attemptSerializer.serialize(attempt) : undefined,
            responses: responses
                ? responses.map(function (response) { return _this.serializeRubricSelection(response); })
                : [],
        });
    };
    AttemptRubricSelectionSerializer.prototype.serializeRubricSelection = function (_a) {
        var _this = this;
        var externalQuestionId = _a.externalQuestionId, criteriaSelections = _a.criteriaSelections, answerDoesNotApply = _a.answerDoesNotApply;
        return new models_1.RubricSelection({
            answerDoesNotApply: answerDoesNotApply,
            externalQuestionId: externalQuestionId,
            criteriaSelections: criteriaSelections
                ? criteriaSelections.map(function (option) { return _this.serializeRubricOption(option); })
                : [],
        });
    };
    AttemptRubricSelectionSerializer.prototype.serializeRubricOption = function (_a) {
        var categoryId = _a.categoryId, criterionId = _a.criterionId, ratingId = _a.ratingId;
        return new models_1.RubricOption({
            categoryId: categoryId,
            criterionId: criterionId,
            ratingId: ratingId,
        });
    };
    return AttemptRubricSelectionSerializer;
}());
exports.AttemptRubricSelectionSerializer = AttemptRubricSelectionSerializer;
